import React, { createContext, useContext, useState } from 'react'

const SidebarCollapseContext = createContext()

export function SidebarCollapseProvider({ children }) {
  const [isCollapsed, setIsCollapsed] = useState(false)

  const toggleCollapse = () => {
    setIsCollapsed(prev => !prev)
  }

  return (
    <SidebarCollapseContext.Provider value={{ isCollapsed, toggleCollapse }}>
      {children}
    </SidebarCollapseContext.Provider>
  )
}

export function useSidebarCollapse() {
  const context = useContext(SidebarCollapseContext)
  if (!context) {
    return { isCollapsed: false, toggleCollapse: () => {} }
  }
  return context
}
